import * as R from 'ramda';
import { getStore } from 'store/store';
import features from 'system/features';
import { ApiHelper } from 'utils/apiHelper';
import yaml from 'yaml';

import { Environment } from 'Environment';
import { WhiteLabelSelectors } from 'reactApp/modules/WhiteLabelModule/WhiteLabelModule';

const getBucketUrl = () => {
    if (WhiteLabelSelectors.getMarketplace(getStore())) {
        return WhiteLabelSelectors.getMarketplace(getStore()).url;
    }

    const urlParamToName = {
        versions: 'marketplace-versions',
        dev: 'marketplace-dev',
        prod: 'marketplace-prod',
    };

    let bucket;

    if (features.isEnabled('CAN_USE_MARKETPLACE_TEST_BUCKET')) {
        bucket = urlParamToName[Environment.marketplaceBucket];
        if (!bucket) {
            bucket = Environment.isProductionHost
                ? urlParamToName.prod
                : urlParamToName.dev;
        }
    } else {
        bucket = urlParamToName.prod;
    }

    return `https://${bucket}.mcs.st`;
};

const makeTemplateFolderUrl = (configuration) =>
    `${getBucketUrl()}/${configuration.template_folder}/${
        configuration.bundle_version
    }`;

const makeTemplateFileUrl = R.curry(
    (configuration, file) => `${makeTemplateFolderUrl(configuration)}/${file}`,
);

const makeLogoUrl = (configuration) =>
    makeTemplateFileUrl(configuration, 'logo.svg');

export const TemplateApi = {
    makeLogoUrl,

    async loadConfigurationList() {
        const content = await ApiHelper.loadText(
            `${getBucketUrl()}/configurations.json`,
        );
        return JSON.parse(content);
    },

    async loadTemplate(configuration) {
        const makeUrl = makeTemplateFileUrl(configuration);

        const [
            templateYaml,
            metadataYaml,
            quick_start_manual,
        ] = await Promise.all([
            ApiHelper.loadText(makeUrl('stack.yml')),
            ApiHelper.loadText(makeUrl('metadata.yml')),
            ApiHelper.loadText(makeUrl('HOWTO.md')),
        ]);

        const metadata = R.assoc(
            'quick_start_manual',
            quick_start_manual,
        )(yaml.parse(metadataYaml));

        return R.assoc('metadata', metadata)(yaml.parse(templateYaml));
    },

    async loadAdditionalFile({
        rootFilePath,
        templateFilePath,
        configuration,
    }) {
        const url = rootFilePath
            ? `${getBucketUrl()}/${rootFilePath}`
            : makeTemplateFileUrl(configuration, templateFilePath);
        return ApiHelper.loadText(url);
    },

    async getAdditionalStacksFolderInfo(configuration) {
        return ApiHelper.loadXml(getBucketUrl(), {
            'list-type': 2,
            delimeter: '%2F',
            'max-keys': 1000,
            prefix: `${configuration.template_folder}/${configuration.bundle_version}/additional_stacks`,
        });
    },
};
